<template>
  <el-dialog
    title="云打印机"
    width="520px"
    :visible.sync="dialog.isShow"
    @close='closeDialog'
    @open='openDialog'
  >
    <el-form
      ref="ruleForm"
      :model="form"
      label-width="80px"
      class="dr-form"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="所属店铺"
            prop="name"
          >
          <el-input v-model="form.storeName" readonly placeholder="所属店铺">
            <el-button slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
          </el-input> 
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="id"
            prop="deviceId"
          >
          <el-input v-model="form.deviceId" placeholder="请输入Id"></el-input>   
          </el-form-item>
        </el-col>        
        <el-col :span="24">
          <el-form-item
            label="secretkey"
            prop="secretkey"
          >
          <el-input v-model="form.secretkey" placeholder="请输入secretkey"></el-input>   
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dr-dialog-footer"
    >
      <el-button @click="dialog.isShow = false">
        关 闭
      </el-button>
      <el-button
        type="primary"
        @click="Save"
      >
       保 存
      </el-button>
    </div>
    <GetChainStore v-bind:dialogStore="dialogStore" @UpdateSote="UpdateSote"></GetChainStore>
   </el-dialog>
</template>
<script  type='text/ecmascript-6'>
  import GetChainStore from '@/components/GetChainStore'
  import GetProduct from '@/components/GetProduct'
  import GetMeasuredService from '@/components/GetMeasuredService'
  import GetFlashSale from '@/components/GetFlashSale'
  import { Loading } from 'element-ui';
  export default {
    props:{
      dialog:{}
    },
    data(){
      return {
        loading:false,
        form:{
          id:0,
          storeName:'',
          chainStoreId:0,
          deviceId:'',
          secretkey:''
        },
        name:'',
        dialogStore:{
          isShow:false
        },
      }
    },
    mounted(){
      
    },
    components:{    
      GetChainStore
    },
    methods:{
     
      selectStoreHandle:function(){
        this.dialogStore.isShow = true
      },   
      UpdateSote:function(id,name){
        this.form.chainStoreId = id 
        this.form.storeName = name 
      },  
      closeDialog:function(){
        this.dialogStoreIsShow = false
      },
      openDialog:function(){
        debugger
        this.form.id = this.dialog.id
        this.form.chainStoreId = this.dialog.storeId
        this.form.storeName = this.dialog.storeName
        this.form.deviceId =this.dialog.deviceId
        this.form.secretkey = this.dialog.secretkey
      },
      Save:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Hardware/PrinterSave',         
          data:this.form
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);            
            that.$emit('GetData')
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    }
   }
</script>
